import { React, useContext, useEffect, useState } from 'react'
import {
  Button,
  Icon,
  Table,
  Pagination,
  Dropdown,
  Grid,
} from 'semantic-ui-react'
import { DebounceInput } from 'react-debounce-input'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import {
  setCustomerData,
  RefreshCustomerAssetList,
} from '../../../redux/actions/asset'
import { AssetViewContext } from '../asset-info-view/assetView'
import styles from '../asset-info-view/asset-view.module.css'
import classes from './assetList.module.css'
import { history } from '../../../redux/store'
import IntelMsg from '../../ItelMsg'
import {
  GetAssetInfo,
  GetPaginationAssetsList,
  GetUserCustomers,
  ChangeAssetStatus,
} from '../../../services/asset/index'
import UpdateHierarchyModal from './updateHierarchyModal'
import StatusDialog from '../../status-dialog'

const AssetList = () => {
  const [open, setOpen] = useState(false)
  const [assetList, setAssetList] = useState([])
  const [noOfPages, setNoOfPages] = useState(0)
  const [customersList, setCustomersList] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState(
    localStorage.getItem('customer'),
  )
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)
  const [customerName, setCustomerName] = useState()
  const [modalData, setModalData] = useState({})
  const [search, setSearch] = useState('')
  const [pageSize] = useState(10)
  const {
    setViewAsset,
    setAssetData,
    setAssetCustomerData,
    setOpenTemplateDialog,
    setAssetAssignModal,
  } = useContext(AssetViewContext)
  const [activePage, setActivePage] = useState(0)
  // TODO refresh asset list
  const dispatch = useDispatch()
  const productName = localStorage.getItem('product')
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const customerData = []

  useEffect(() => {
    GetUserCustomers(userEmail, productName).then((customers) => {
      customers.forEach((customer) => {
        customerData.push({
          text: customer.title,
          value: customer.tbCustomerId,
        })
      })
      setCustomersList(customerData)
    })
  }, [])

  useEffect(() => {
    setSelectedCustomer(localStorage.getItem('customer'))
    if (customersList.length > 0) {
      const cust = customersList.filter(
        (el) => el.value === localStorage.getItem('customer'),
      )
      console.log('cccs', cust.text)
      if (cust[0]) setCustomerName(cust[0].text)
    }
    console.log('[localStorage]')
  }, [localStorage.getItem('customer')])

  useEffect(() => {
    if (selectedCustomer) {
      if (search !== '') {
        GetPaginationAssetsList(
          userEmail,
          productName,
          activePage,
          pageSize,
          selectedCustomer,
          search,
        ).then((data) => {
          console.log('data.data::::: ', data.data)
          setAssetList(data.data)
          setNoOfPages(data['no of pages'])
        })
      } else
        GetPaginationAssetsList(
          userEmail,
          productName,
          activePage,
          pageSize,
          selectedCustomer,
        ).then((data) => {
          console.log('data.data::::: ', data.data)
          setAssetList(data.data)
          setNoOfPages(data['no of pages'])
        })
    }
    console.log('[activePage, selectedCustomer, search]')
  }, [activePage, selectedCustomer, search])

  const onDetailsClick = async (item) => {
    console.log('onDetailsClick')
    try {
      const assetData = await GetAssetInfo(
        item['asset name'],
        userEmail,
        productName,
      )
      setAssetData({ ...assetData, assetId: item['asset id'] })
      setViewAsset(true)
    } catch (e) {
      setDialogContent(
        <>
          <Icon name="exclamation triangle" size="huge" color="red" />
          <p style={{ fontSize: 'x-large' }}>{e.message}</p>
        </>,
      )
      setShowStatusDialog(true)
    }
  }

  const handleStatusChange = (item) => {
    console.log('changed: ', item)
    Swal.fire({
      title: 'Are You Sure You Want To Change Asset Status?',
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      confirmButtonColor: 'green',
      denyButtonColor: 'red',
      customClass: {
        actions: 'my-actions',
        confirmButton: 'order-2',
        denyButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeAssetStatus(item['asset id'], item.status).then((res) => {
          console.log('ressss: ', res)
          if (res.status === 202) {
            Swal.fire({
              title: 'Asset Status Changed Successfully!',
              confirmButtonColor: 'Green',
              icon: 'success',
            })
            dispatch(RefreshCustomerAssetList(true))
          } else
            Swal.fire({
              title: 'Error Changing Asset Status!',
              confirmButtonColor: 'Red',
              icon: 'error',
            })
        })
      }
    })
  }

  const onConfigureClick = (item) => {
    setOpenTemplateDialog(true)
    setAssetCustomerData(selectedCustomer)
    setAssetData(item)
  }
  const onAssignClick = (item) => {
    setAssetAssignModal(true)
    setAssetCustomerData(selectedCustomer)
    setAssetData(item)
  }
  const onChange = (e, pageInfo) => {
    setActivePage(pageInfo.activePage - 1)
  }

  const onUpdateClick = (data) => {
    setOpen(true)
    setModalData({ ...data, customerId: selectedCustomer, userEmail })
  }

  // eslint-disable-next-line no-nested-ternary
  const listItems = assetList ? (
    assetList.length > 0 ? (
      assetList.map((item) => (
        <Table.Row key={item['asset id']}>
          <Table.Cell width={4}>
            {item['asset label'] || item['asset name']}
          </Table.Cell>
          <Table.Cell>{item['asset type']}</Table.Cell>
          <Table.Cell width={6} style={{ textAlign: 'center' }}>
            <Button animated size="small" onClick={() => onDetailsClick(item)}>
              <Button.Content style={{ fontSize: '7pt' }} hidden>
                <IntelMsg id="DETAILS" />
              </Button.Content>
              <Button.Content visible>
                <Icon name="ellipsis horizontal" />
              </Button.Content>
            </Button>
            <Button
              animated
              style={{ width: '80px' }}
              size="medium"
              onClick={() => onUpdateClick(item)}
            >
              <Button.Content className={classes.btn} hidden>
                Update Hierarchy
              </Button.Content>
              <Button.Content visible>
                <Icon name="settings" />
              </Button.Content>
            </Button>
            <Button
              animated
              size="medium"
              onClick={() => onConfigureClick(item)}
            >
              <Button.Content className={classes.btn} hidden>
                <IntelMsg id={item.status} />
              </Button.Content>
              <Button.Content visible>
                <Icon name="setting" />
              </Button.Content>
            </Button>

            <Button animated size="small" onClick={() => onAssignClick(item)}>
              <Button.Content style={{ fontSize: '7pt' }} hidden>
                <IntelMsg id="ASSIGN" />
              </Button.Content>
              <Button.Content visible>
                <Icon name="sign-in" />
              </Button.Content>
            </Button>

            {item.status === 'CONFIGURED' ? (
              <Button
                animated
                size="small"
                onClick={() => {
                  handleStatusChange(item)
                }}
              >
                <Button.Content hidden style={{ width: '85px' }}>
                  Deactivate
                </Button.Content>
                <Button.Content visible style={{ width: '50px' }}>
                  <Icon name="recycle" />
                </Button.Content>
              </Button>
            ) : (
              <Button disabled animated size="small">
                <Button.Content hidden style={{ width: '85px' }}>
                  Activate
                </Button.Content>
                <Button.Content visible style={{ width: '50px' }}>
                  <Icon name="recycle" />
                </Button.Content>
              </Button>
            )}
          </Table.Cell>
        </Table.Row>
      ))
    ) : (
      <Table.Row>
        <Table.Cell colSpan="3">
          <p style={{ textAlign: 'center' }}>
            <strong>
              <IntelMsg id="thereIsNoDevicesToShow" />
            </strong>
          </p>
        </Table.Cell>
      </Table.Row>
    )
  ) : (
    <Table.Row>
      <Table.Cell colSpan="3">
        <p style={{ textAlign: 'center' }}>
          <strong>
            <IntelMsg id="thereIsNoDevicesToShow" />
          </strong>
        </p>
      </Table.Cell>
    </Table.Row>
  )

  return (
    <>
      <Dropdown
        placeholder="select Customer"
        fluid
        search
        selection
        value={selectedCustomer || ''}
        options={customersList}
        style={{ marginBottom: '2rem' }}
        onChange={(e, data) => {
          const title = e.target.innerHTML.replace('<span class="text">', '')
          setCustomerName(title.replace('</span>', ''))
          localStorage.setItem('customerName', title.replace('</span>', ''))
          setSelectedCustomer(data.value)
          dispatch(setCustomerData(data.value))
          localStorage.setItem('customer', data.value)
        }}
      />

      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={2}>
            <b>Search:</b>
          </Grid.Column>
          <Grid.Column>
            <DebounceInput
              debounceTimeout={400}
              style={{
                width: 347,
                height: 40,
                border: '1px solid',
                outline: 'none',
              }}
              placeholder="Search with asset name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <br />

      <div className={styles.container}>
        {customerName}
        <IntelMsg id="assetsList" />
      </div>
      <Table compact celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <IntelMsg id="assetName" />
            </Table.HeaderCell>
            <Table.HeaderCell collapsing>
              <IntelMsg id="assetType" />
            </Table.HeaderCell>
            <Table.HeaderCell style={{ textAlign: 'center' }}>
              <IntelMsg id="actions" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body className={classes.tableBody}>
          <>{listItems}</>
        </Table.Body>
      </Table>
      <Table.Footer className={classes.footer} colSpan={2}>
        <Pagination
          floating="right"
          activePage={activePage + 1}
          onPageChange={(e, data) => onChange(e, data)}
          totalPages={noOfPages}
          firstItem={{
            content: <Icon name="angle double left" />,
            icon: true,
          }}
          lastItem={{
            content: <Icon name="angle double right" />,
            icon: true,
          }}
          prevItem={{ content: <Icon name="angle left" />, icon: true }}
          nextItem={{ content: <Icon name="angle right" />, icon: true }}
        />
      </Table.Footer>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Asset" />}
        dialogContent={dialogContent}
      />
      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: '#303d54', color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>

      <UpdateHierarchyModal open={open} setOpen={setOpen} asset={modalData} />
    </>
  )
}

AssetList.propTypes = {}

export default AssetList
